import { getAuthToken, getUserInfo } from "./vk";
import { getCashier } from "./db";
import {setCashier} from "../store/cashier/actions";

export const authUser = () => async(dispatch) => {
    // Получаем ВК информацию пользователя из приложения
    let userInfoPromise = dispatch(getUserInfo());

    // Получаем токен ВК
    let tokenPromise = dispatch(getAuthToken());

    // Задаем URL-параметры приложения как локальную переменную
    let userInfo = await userInfoPromise;
    localStorage.setItem('url', window.location.href);
    localStorage.setItem('vk_id', userInfo.vkUser.id);

    // DEVMOCK
    if (process.env.NODE_ENV === 'development') {
        localStorage.setItem('url', 'https://festapp.vk-admin.com/build/?vk_access_token_settings=&vk_app_id=7007571&vk_are_notifications_enabled=0&vk_is_app_user=1&vk_language=ru&vk_platform=desktop_web&vk_user_id=4267535&sign=hwfoTjxYqbUXu6mhVmxijs7ZWBeWH4T8B4Fgpe8ay3s');
        localStorage.setItem('vk_id', '4267535');
    }

    // Получаем кассира
    let cashierInfo = { status: false, cashier: {} };
    if (userInfo.vkUser.id !== undefined) {
        const result = await dispatch(getCashier(userInfo.vkUser.id));
        if (result.data.data.result !== undefined && result.data.data.result === 'success') {
            cashierInfo = { status: true, cashier: result.data.data.data };
        }
    }
    await dispatch(setCashier(cashierInfo.status, cashierInfo.cashier));

    await tokenPromise;
};


// WEBPACK FOOTER //
// ./src/js/services/auth.js